import { cn } from '@/lib/utils';
import { Check } from 'lucide-react';
import H3 from '../ui/H3';
import P from '../ui/P';
import Button from '../ui/Button';
import { useTranslations } from 'next-intl';

export default function FormSuccess({
    className,
    onClickBack,
    color = 'black',
}: {
    className?: string;
    onClickBack: () => void;
    color?: 'white' | 'black';
}) {
    const t = useTranslations();

    const isBlack = color === 'black';

    return (
        <div
            className={cn(
                'border border-gray-300 py-[70px] px-4 flex flex-col gap-7 justify-center items-center',
                !isBlack && 'border-white',
                className,
            )}
        >
            <Check
                className={cn('text-primary', !isBlack && 'text-white')}
                width={64}
                height={64}
            />
            <H3 className={cn('uppercase text-center', !isBlack && 'text-white')}>
                {t('Form.successTitle')}
            </H3>
            <P
                className={cn(
                    'max-w-[304px] w-full text-center font-light',
                    !isBlack && 'text-white',
                )}
            >
                {t('Form.successSubtitle')}
            </P>
            <Button
                variant="primary"
                title={t('Buttons.sendNew')}
                onClick={onClickBack}
                color={isBlack ? 'blue' : 'white'}
            />
        </div>
    );
}
